import esLabel from "../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login_es.json";
import frLabel from "../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login_fr.json";
import enLabel from "../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login.json";
import csLabel from "../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login_cs.json";
import nlLabel from "../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login_nl_NL.json";
import deLabel from "../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login_de.json";
import brLabel from "../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login_pt_BR.json";

export const oktaLocalization = () => {
    return {
        esLabel: { ...esLabel },
        frLabel: { ...frLabel },
        enLabel: { ...enLabel },
        frCaLabel: { ...frLabel },
        csLabel: { ...csLabel },
        nlLabel: { ...nlLabel },
        ukLabel: { ...enLabel },
        deLabel: { ...deLabel },
        mxLabel: { ...esLabel },
        brLabel: { ...brLabel },
    };
};
